import { render, staticRenderFns } from "./AnswerLabel.vue?vue&type=template&id=652ef55b&scoped=true"
import script from "./AnswerLabel.vue?vue&type=script&lang=js"
export * from "./AnswerLabel.vue?vue&type=script&lang=js"
import style0 from "./AnswerLabel.vue?vue&type=style&index=0&id=652ef55b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ef55b",
  null
  
)

export default component.exports